import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const DocumentsTabIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1H3.75C3.05964 1 2.5 1.55964 2.5 2.25V13.75C2.5 14.4404 3.05964 15 3.75 15H12.25C12.9404 15 13.5 14.4404 13.5 13.75V8.5C13.5 7.11929 12.3807 6 11 6H9.75C9.05964 6 8.5 5.44036 8.5 4.75V3.5C8.5 2.11929 7.38071 1 6 1ZM10.4069 8.29062C10.5674 8.06591 10.5153 7.75364 10.2906 7.59313C10.0659 7.43263 9.75364 7.48467 9.59313 7.70938L7.4362 10.7291L6.35355 9.64645C6.15829 9.45118 5.84171 9.45118 5.64645 9.64645C5.45118 9.84171 5.45118 10.1583 5.64645 10.3536L7.14645 11.8536C7.25037 11.9575 7.39476 12.0104 7.54124 11.9983C7.68772 11.9862 7.82144 11.9102 7.90687 11.7906L10.4069 8.29062Z"
      fill="currentColor"
    />
    <path
      d="M8.64746 1.2106C9.17864 1.82432 9.5 2.62463 9.5 3.5V4.75C9.5 4.88807 9.61193 5 9.75 5H11C11.8754 5 12.6757 5.32136 13.2894 5.85254C12.6975 3.58658 10.9134 1.80252 8.64746 1.2106Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentsTabIcon;
